import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { SettingsProvider } from "./context/SettingsContext";
import { ToastsProvider } from "./context/ToastsContext";
import "./styles/App.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<ToastsProvider>
		<SettingsProvider>
			<App />
		</SettingsProvider>
	</ToastsProvider>
);
